import request from '@/utils/request';


export const findOrderStatistics = query => {

    var list = request({
        url: 'orderStatistics/findData',
        method: 'post',
        params: query
    });
    return list;
};
export const findDataByDataBody5 = query => {

    var list = request({
        url: 'orderStatistics/findDataByDataBody5',
        method: 'post',
        params: query
    });
    return list;
};

export const findDataByDataBody6 = query => {

    var list = request({
        url: 'orderStatistics/findDataByDataBody6',
        method: 'post',
        data: query,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',

        }
    });
    return list;
};
export const findEchartByDataBody5 = query => {

    var list = request({
        url: 'orderStatistics/findEchartByDataBody5',
        method: 'post',
        params: query
    });
    return list;
};

export const dataStatistics = query => {

    var list = request({
        url: 'orderStatistics/dataStatistics',
        method: 'post',
        params: query
    });
    return list;
};
export const conversionAnalysis = query => {

    var list = request({
        url: 'orderStatistics/conversionAnalysis',
        method: 'post',
        params: query
    });
    return list;
};

export const conversionAnalysisByProductAndMember = query => {

    var list = request({
        url: 'orderStatistics/conversionAnalysisByProductAndMember',
        method: 'post',
        params: query
    });
    return list;
};

export const failAnalysis = query => {

    var list = request({
        url: 'orderStatistics/failAnalysis',
        method: 'post',
        params: query
    });
    return list;
};
export const dataStatistics30 = query => {

    var list = request({
        url: 'orderStatistics/findData30',
        method: 'post',
        params: query
    });
    return list;
};
export const findDataByTodayAndThisMonth = query => {

    var list = request({
        url: 'orderStatistics/findDataByTodayAndThisMonth',
        method: 'post',
        params: query
    });
    return list;
};